module.exports = __webpack_public_path__ + "files/36bf3006f511c376eec61f904cf5ef15.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-6.png
// module id = 1481
// module chunks = 60